import { render, staticRenderFns } from "./retailorder.vue?vue&type=template&id=39365efe&scoped=true"
import script from "./retailorder.vue?vue&type=script&lang=js"
export * from "./retailorder.vue?vue&type=script&lang=js"
import style0 from "./retailorder.vue?vue&type=style&index=0&id=39365efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39365efe",
  null
  
)

export default component.exports